import Modal from 'react-modal'
import { Container, ModalBody, ModalHeader } from './styles'
import { MdClose } from 'react-icons/md'
import { FaCheckCircle, FaPlus } from 'react-icons/fa'
import { iModalPadrao, iQuestao } from '../../../../../interfaces'
import { useEffect, useState } from 'react'
import { ModalQuestao } from '../ModalQuestao'
import { useFormulario } from '../../../../../contexts/FormularioContext'
import { Box, Flex } from '@chakra-ui/react'
import { ButtonCmp } from '../../../../../components/ButtonCmp'

interface IModalProps extends iModalPadrao {
  CompetenciaId: string
}

export const ModalPreVizualizarQuestao: React.FC<IModalProps> = ({ OnCloseModal, isOpen, CompetenciaId }) => {
  if (!isOpen) {
    return null
  }
  const { SelectQuestao, ctxFormulario, ctxCompetencias } = useFormulario()
  const [CriarIsOpen, setCriarIsOpen] = useState(false)

  const [Questoes, setQuestoes] = useState<iQuestao[]>([])

  const Selecionados = ctxFormulario.selecoes.find(e => e.competenciaId === CompetenciaId)

  function getQuestoes(): void {
    const competencia = ctxCompetencias.find(e => e.id === CompetenciaId)
    if (competencia !== undefined) {
      setQuestoes(competencia.questoes)
    }
  }

  useEffect(() => {
    getQuestoes()
  }, [ctxCompetencias])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={OnCloseModal}
      overlayClassName='react-modal-overlay'
      className={'react-modal-content-scroll'}
    >
      <ModalQuestao
        competenciaId={CompetenciaId}
        OnCloseModal={() => setCriarIsOpen(false)}
        duplicar={false}
        isOpen={CriarIsOpen}
      />

      <Container>
        <ModalHeader>
          <Flex alignItems={'center'}>
            <img src={ctxCompetencias.find(e => e.id === CompetenciaId)?.icone} />
            <h4>{ctxCompetencias.find(e => e.id === CompetenciaId)?.nome}</h4>
          </Flex>
          <Box style={{ color: 'var(--Red)' }}>
            <MdClose
              onClick={() => OnCloseModal()}
              cursor={'pointer'}
              size={18}
            />
          </Box>
        </ModalHeader>

        <ModalBody>
          {
            Questoes.map((e: iQuestao, i) => {
              if (Selecionados?.questoesId.find(r => r === e.id) !== undefined) {
                return (
                  <div onClick={() => SelectQuestao(CompetenciaId, e.id)} key={i}>
                    <FaCheckCircle color='var(--Azul)' size={18} />
                    <span>{e.enunciado}</span>
                  </div>
                )
              }
              return (
                <div onClick={() => SelectQuestao(CompetenciaId, e.id)} key={i}>
                  <FaCheckCircle color='var(--c7)' size={18} />
                  <span>{e.enunciado}</span>
                </div>
              )
            })
          }
        </ModalBody>

        <Flex gap={'.5rem'} justifyContent={'end'}>
          <ButtonCmp VarColor='Rosa' onClick={() => setCriarIsOpen(true)} leftIcon={<FaPlus />}>Criar questão</ButtonCmp>
          <ButtonCmp VarColor='Green2' onClick={() => OnCloseModal()}>Continuar</ButtonCmp>
        </Flex>
      </Container>
    </Modal>
  )
}
